import * as React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <path d="M22.33,4.6a2,2,0,0,1,1.9,1.31h0L27,13.7V24.1a1.32,1.32,0,0,1-1.33,1.3H24.33A1.32,1.32,0,0,1,23,24.1h0V22.8H7v1.3a1.32,1.32,0,0,1-1.33,1.3H4.33A1.32,1.32,0,0,1,3,24.1H3V13.7L5.77,5.91A2,2,0,0,1,7.67,4.6H22.33ZM8.6,15.8A2.4,2.4,0,1,0,11,18.2,2.39,2.39,0,0,0,8.6,15.8Zm12.8,0a2.4,2.4,0,1,0,2.4,2.4A2.39,2.39,0,0,0,21.4,15.8Zm.45-8.6H8.13l-1.44,4h16.6Z" />,
  'Car'
)
